import { Check } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { ScaledDoc } from "@/components/resume/ScaledDoc";
import { SAMPLE, TEMPLATES } from "@/lib/resume";
import { cn } from "@/lib/utils";

export const TemplatePicker = ({ open, onClose, value, onChange, data }) => {
  const preview = data?.personal?.full_name ? data : SAMPLE;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[calc(100dvh-1.5rem)] border-[#27272A] bg-[#141417] sm:max-h-[90vh] sm:max-w-5xl" data-testid="template-picker-dialog">
        <DialogTitle className="font-display text-zinc-100">Choose a template</DialogTitle>
        <DialogDescription className="text-zinc-400">Every template exports as a single-column, text-based PDF that ATS systems can read.</DialogDescription>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
          {TEMPLATES.map((t) => (
            <button key={t.id} type="button" onClick={() => { onChange(t.id); onClose(); }} data-testid={`template-option-${t.id}`}
              className={cn("group text-left transition-transform hover:-translate-y-0.5", value === t.id && "[&_.thumb]:ring-2 [&_.thumb]:ring-[#D4AF37]")}>
              <div className="thumb relative h-56 overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-[#27272A] sm:h-64">
                <ScaledDoc data={preview} template={t.id} className="pointer-events-none" />
                {value === t.id && <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#D4AF37] text-black"><Check className="h-4 w-4" /></span>}
              </div>
              <div className="mt-2 text-sm font-medium text-zinc-100 group-hover:text-[#F3C649]">{t.name}</div>
              <div className="text-[11px] text-zinc-500">{t.blurb}</div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
